<div class="animated-notification-container ">
  <div>
    <i class="allycon-checkmark text-white text-center"></i>
  </div>
  <p class="text-center" role="alert">{{ message }}</p>
</div>
